// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ResumeBuildingHome_mainWrapper__RmlHK","leftWrapper":"ResumeBuildingHome_leftWrapper__a9H5t","rightWrapper":"ResumeBuildingHome_rightWrapper__d6TVu"};